// removed by extract-text-webpack-plugin
module.exports = {"root":"_3433EKmW741JRBxtDQEorE","label":"_2_zMfujVJzvF7sGIt7nHEC","checkbox":"_2qwTK9JAO7e4qFfEFuyVc7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/radio-box.scss
// module id = 1169
// module chunks = 0